"use client"

import { useCallback } from "react"

interface UseViewToggleProps {
  myUsers: any[]
  activePhone: string | null
  conversationCounts?: { [phone: string]: number }
  setActivePhone: (phone: string | null) => void
  setViewingNotifications: (value: any) => void
  setIsHistoryPage: (value: any) => void
  setSelectedConversationId: (id: string | null) => void
  setSelectedConversationLastDate: (date: string | null) => void
  isHistoryPage: boolean
  setActiveNotification: any
}

export const useViewToggle = ({
  myUsers,
  activePhone,
  conversationCounts,
  setActivePhone,
  setViewingNotifications,
  setIsHistoryPage,
  setSelectedConversationId,
  setSelectedConversationLastDate,
  isHistoryPage,
  setActiveNotification
}: UseViewToggleProps) => {
  const handleViewHistoryToggle = useCallback(() => {
    const currentUser = myUsers.find((u) => u.phone === activePhone)
    const chatCount = currentUser ? conversationCounts?.[currentUser.phone] || 0 : 0

    if (chatCount === 0) {
      setActivePhone(null)
    }
    if (isHistoryPage) {
      setActivePhone(null)
      setActiveNotification(null)

    }
    setViewingNotifications((prev: any) => !prev)
    setIsHistoryPage((prev: any) => !prev)
    setSelectedConversationId(null)
    setSelectedConversationLastDate(null)
  }, [
    myUsers,
    activePhone,
    conversationCounts,
    setActivePhone,
    setViewingNotifications,
    setIsHistoryPage,
    setSelectedConversationId,
    setSelectedConversationLastDate,
  ])

  return {
    handleViewHistoryToggle,
  }
}
